'use client';

import React, { useMemo } from 'react';

import Button from '@/common/components/button';
import SettingDropDown from '@/common/components/setting/settingDropDown.component';
import { useSession } from '@/common/hooks/use-session.hook';

interface UserProfileProps {
  onLoginClick: () => void;
}
const UserProfile = ({ onLoginClick }: UserProfileProps) => {
  const { status } = useSession();

  const profileStatus = useMemo(() => {
    switch (status) {
      case 'authenticated':
        return <SettingDropDown status={status} />;
      case 'unauthenticated':
        return (
          <Button
            type="black"
            className="mr-[20px] !h-full !w-[96px] !rounded-[8px] !border-none !text-[11px]"
            onClick={onLoginClick}
          >
            ورود/ ثبت نام
          </Button>
        );
      default:
        return <SettingDropDown status={'loading'} />;
    }
  }, [status]);
  return <>{profileStatus}</>;
};

export default UserProfile;
